import React from 'react'
import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../form/InputField';

export interface LoyaltyOfferFormData {
  endDate: string | null;
  startDate: string | null;
  amountRequired:number,
  bonusAmount:number
}

interface Props {
  register: UseFormRegister<LoyaltyOfferFormData>;
  errors: FieldErrors<LoyaltyOfferFormData>;
  watch: UseFormWatch<LoyaltyOfferFormData>; // 👈 add watch to check values,
}

function LoyaltyOfferForm({ register, errors, watch}: Props) {
  const { t } = useTranslation();
  const start = watch("startDate");

  return (
    <>
     <div className="grid sm:grid-cols-2 gap-4">
      {/* Start Date (optional) */}
      <InputField
        placeholder=""
        label={t("amountRequired")}
        register={register("amountRequired")}
        type="number"
        error={errors.amountRequired}
      />

      {/* End Date (optional, but must be after startDate if provided) */}
      <InputField
        placeholder=""
        label={t("bonusAmount")}
        register={register("bonusAmount")}
        type="number"
        error={errors.bonusAmount}
      />
    </div>
    <div className="grid sm:grid-cols-2 gap-4">
      {/* Start Date (optional) */}
      <InputField
        placeholder=""
        label={t("startDate")}
        register={register("startDate")}
        type="datetime-local"
        error={errors.startDate}
        defaultValue={""}
      />

      {/* End Date (optional, but must be after startDate if provided) */}
      <InputField
        placeholder=""
        label={t("endDate")}
        register={register("endDate", {
          validate: (value) =>
            !value || !start || new Date(value) > new Date(start) || t("endDate_must_be_after_startDate")
        })}
        type="datetime-local"
        error={errors.endDate}
      />
    </div>
     </>
  );
}

export default LoyaltyOfferForm;
